import { IModelCarouselData } from '../model-carousel/model-carousel.interface';

export enum EModelProductView {
    Product = 'product',
    Model = 'model'
}

export enum EModelProductLabel {
    Base = 'base',
    Alternative = 'alternative'
}

export interface ICustomCategoryItem {
    image: string;
    copy: string;
    url: string;
    forceTitleTag?: string;
    textStyle?: string;
}

export interface ILocalModelCarouselData extends IModelCarouselData {
    title_tag: string;
    title_color?: string;
    cta_color?: string;
    product_view: EModelProductView;
    product_label: EModelProductLabel;
    product_hide_price: boolean;
    product_hide_name: boolean;
    product_hide_label: boolean;
    product_hide_video: boolean;
    product_list?: boolean;
    carousel_loop: boolean;
    carousel_marquee: number;
    carousel_marquee_speed: number;
    carousel_nested: boolean;
    cursor_color?: string;
    custom_items?: ICustomCategoryItem[];
}
